import apis from "../../core/apis.js";

class TagResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.tags).get(options);
  }

  get(id) {
    return this.$resource(apis.tags + id).get();
  }

  post(item) {
    return this.$resource(apis.tags).save(item);
  }

  updateAction(id, name, item) {
    return this.$resource(apis.tags + id + `/${name}`).save(item);
  }
}

export default TagResource;



// WEBPACK FOOTER //
// ./src/resources/tag/tag.resource.js